/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Service = {
  properties: {
    pk: {
      type: "number",
      isReadOnly: true,
    },
    project: {
      type: "number",
      isRequired: true,
    },
    name: {
      type: "string",
      isReadOnly: true,
    },
    service_type: {
      type: "string",
      isReadOnly: true,
    },
    repository: {
      type: "string",
      isNullable: true,
      maxLength: 200,
    },
    dockerfile: {
      type: "string",
      isNullable: true,
      maxLength: 200,
    },
    health_check: {
      type: "string",
      isRequired: true,
      maxLength: 200,
      minLength: 1,
    },
    container_port: {
      type: "string",
      isNullable: true,
      maxLength: 10,
    },
    date_created: {
      type: "string",
      isReadOnly: true,
    },
    date_updated: {
      type: "string",
      isReadOnly: true,
    },
  },
};
